import { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getUsuarioComite, useComite } from '../../../../../../appStore/comite';

const MarginButton = styled(Button)`
  margin-top: 30px;
`;
type UsuarioProps = {
  apellido: string;
  calle: string;
  ciudad: { id: number; idProvincia: number; nombre: string };
  codPostal: string;
  cuil: string;
  departamento: string;
  dni: string;
  email: string;
  emailAlternativo: string;
  fechaNacimiento: string;
  genero: string;
  idUsuario: number;
  nacionalidad: { id: number; nombre: string };
  nombre: string;
  numCud: string;
  numero: number;
  pathCud: string;
  pathCvProvisto: string;
  piso: string;
  representacion: string;
  roles: string[];
  sexo: string;
  telefono: string;
  telefonoAlternativo: string;
  usuarioGestor: string;
};
type Props = { onUsuario: (usuario: UsuarioProps | null, values: any) => void };
export const CuilSearchInput = (props: Props) => {
  const { onUsuario } = props;
  const dispatch = useDispatch();
  const [cuil, setCuil] = useState('');

  const { usuario } = useComite();

  const handleCuilSearch = useCallback(() => {
    dispatch(getUsuarioComite({ cuil }));
  }, [dispatch, cuil]);

  useEffect(() => {
    if (usuario === undefined) return;
    onUsuario(usuario, cuil);
  }, [onUsuario, usuario, cuil]);

  return (
    <>
      <Col xs={5}>
        <Form.Control
          id="cuil"
          title="CUIL / CUIT"
          type="number"
          value={cuil}
          onChange={(e) => setCuil(e.target.value)}
        />
      </Col>
      <Col xs={1}>
        <MarginButton variant="primary" onClick={handleCuilSearch}>
          <i className="fa fa-fw fa-search" />
        </MarginButton>
      </Col>
    </>
  );
};
